import { Form, InputNumber } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';

export const ClientelingSettings = ({ form }) => {
  return (
    <SettingsContent title="CLIENTELING" icon={<FontAwesomeIcon icon={['fas', 'handshake']} />} className="w-100-P">
      <DescriptionBox
        className="w-100-P"
        title="Daily Goal"
        description="How many client contacts do you want your associates striving for each day? This will be the default for all stores unless your stores or associates have specific goals (found on the Edit Store or Associate Details pages)."
        input={
          <Form.Item name="dailyContactGoal">
            <InputNumber
              id="DailyGoalInput"
              min={0}
              step={1}
              precision={0}
              placeholder="4"
              style={{ minWidth: '108px' }}
            />
          </Form.Item>
        }
      />
    </SettingsContent>
  );
};
